import React from "react";
import ReactDOM from  "react-dom";
import _ from 'lodash';
import Template from "./plan.rt";
import { subscribePlan, createAccount } from "../../gateway/backend";

export default class Plan extends React.Component {
  constructor(props) {
    super(props)

   this.state = {
      accountSignupModal: false,
     disableGetStartedButton: false,
    }

    this.toggleAccountSignupModal = this.toggleAccountSignupModal.bind(this);
    this.redirectToDashboard = this.redirectToDashboard.bind(this);
    this.handlePayment = this.handlePayment.bind(this);
    this.toggleScroll = this.toggleScroll.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  toggleAccountSignupModal(planName) {
    const planDetails = talktype.config.plans ? talktype.config.plans.find(plan => plan.name === planName) : {};
    this.setState({
      accountSignupModal: !this.state.accountSignupModal,
      selectedPlans: planDetails
    }, () => this.toggleScroll());
  }

  toggleScroll() {
    if(this.state.accountSignupModal) {
      document.body.classList.add("scroll-disable");
    }
    else {
      document.body.classList.remove("scroll-disable");
    }
  }

  onSubmit(event, accountDetails, planValues) {
    if(this.state.disableGetStartedButton) return false;
    const form = event.target.parentElement;
    if(form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({disableGetStartedButton: true });
      this.getSubscription(planValues, accountDetails);
    }
  }

  getSubscription({id, price}, accountDetails) {
    subscribePlan(this.props.currentUser.id, id)
      .then((response) => {
	(!response.plan_id && id === "") ?
	  this.createAccount(response, accountDetails) :
	  this.handlePayment(response, accountDetails, price)
      });
  }

  createAccount(response, accountDetails) {
    const razorpayIds = {razorpay_subscription_id: response['razorpay_subscription_id'], razorpay_payment_id: response['razorpay_payment_id']}
    const accountDetailsRazorpayIds = {...accountDetails, ...razorpayIds};
    createAccount(this.props.currentUser.id, accountDetailsRazorpayIds)
      .then(() => {
	this.redirectToAdmin();
      });
  }

  handlePayment(response, accountDetails, planPrice) {
    if(response["razorpay_subscription_id"]) {
      const subscription_id = response["id"];
      const options = {
      	"key": metypeHome["razorpay_key"],
      	"amount": planPrice * 100, // 2000 paise = INR 20
      	"name": "Metype",
      	"description": "A modern engagement engine",
      	"handler": (response) => {
          this.createAccount(response, accountDetails);
        },
        "modal": {
        "ondismiss": () => {
           this.setState({disableGetStartedButton: false});
          }
        },
      	"prefill": {
          	  "name": _.get(this.props.currentUser, 'name'),
          	  "email": _.get(this.props.currentUser, 'email')
      	},
      	"theme": {
          	  "color": "#F37254"
      	},
      	"subscription_id": response["razorpay_subscription_id"]
      };
      const rzp1 = new Razorpay(options);
      rzp1.open();
    }
  }

  redirectToDashboard() {
    window.location.href = "/dashboard";
  }

  redirectToAdmin() {
    window.location.href = "/admin";
  }

  getFeatures() {
    const features = _.isArray(this.props.plan.features) ? this.props.plan.features : JSON.parse(this.props.plan.features);

    return _.isArray(features) ? features : [];
  }

  hasFieldInMetadata(fieldName) {
    return !!(this.props.plan.metadata && this.props.plan.metadata[fieldName]);
  }

  render() {
    return Template.call(this);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/metype_home/plan.js